export default __webpack_public_path__ + "static/media/element_spec_56.dc37c15a.webp";